import React from 'react'
import { Link } from 'react-router-dom'
import "../styles/componentsStyles/SettingsSideBar.scss"

const SettingsSideBar = () => {
    return (
        <div className='settings-sidebar'>
            <h2 className='settings-sidebar__title'>Manage Account</h2>
            <ul>
                <li>
                    <Link to="/update-profile">
                        <span class="material-symbols-outlined">
                            settings
                        </span>
                        <p>Profile</p>
                    </Link>
                </li>
                <li>
                    <Link to="/edit-password">
                        <span class="material-symbols-outlined">
                            settings
                        </span>
                        <p>Password</p>
                    </Link>
                </li>
                <li>
                </li>
            </ul>
        </div>
    )
}

export default SettingsSideBar